import axios from 'axios';
import { useDispatch } from 'react-redux';
import { loaderSlice } from '../redux/reducers';

export const useFetch = () => {

    const dispatch = useDispatch();

    const setStoreState = e => {
        const obj = {
            LOADER: () => dispatch(loaderSlice.actions.loaderReducer(e?.value)),
            DEFAULT: () => null
        };
        (obj[e?.key] || obj['DEFAULT'])();
    }

    const api = async (url, method = 'GET', body = null, headers = {}) => {
        setStoreState({ key: 'LOADER', value: true });
        try {
            const response = await axios({
                method,
                url,
                data: body,
                headers
            });

            setStoreState({ key: 'LOADER', value: false })
            return response.data;
        } catch (error) {
            return error;
        } finally {
            setStoreState({ key: 'LOADER', value: false });
        }
    }
    return { api };
}
